function ArrowDown({ size = '8',color="#D9D9D9", style = {} }) {
  return (
    <svg
    width={size}
    height={size}
    viewBox="0 0 10 5"
    fill="none"
    style={{...style}}
  >
    <path
      d="M0.835205 0.5L4.76449 4.42929C4.80355 4.46834 4.86686 4.46834 4.90592 4.42929L8.83521 0.5"
      stroke={color}
      strokeWidth={1.4} 
      strokeLinecap="round"
    />
  </svg>
  );
}

export default ArrowDown;
